const screenType = [
  { id: 1, type: "screenType", label: "Brio Accordion Screen" },
  { id: 2, type: "screenType", label: "Centor Flat Screen/Shade" },
];

export { screenType };
